module.exports = __webpack_public_path__ + "static/media/TheSecretWorldofBriarRose_Bookcover.8bb7f5a3.jpg";